const SET_PREFERENCES = 'SET_PREFERENCES';
const INITIALIZE = 'INITIALIZE';
const RESET_STATE = 'RESET_STATE';

export {
    SET_PREFERENCES,
    INITIALIZE,
    RESET_STATE,
};
